import { roundCentsToWholeDollarCents } from '@fruitful/fruitils';
import { calculateMonthlyTakeHomeCents } from '@fruitful/member-profile';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import type { MembershipDetails } from '../../../entities/entityTypes';
import { getMembershipDetailsQueryKey } from '../../../entities/membership/MembershipDetailsEntityProvider';

export const useRefetchMembershipIncomesAndSyncMoneyMap = ({
    membership,
    persistMonthlyIncomeCentsToMoneyMap,
}: {
    membership: MembershipDetails | null;
    persistMonthlyIncomeCentsToMoneyMap: (
        monthlyIncomeCents: number,
    ) => Promise<boolean>;
}) => {
    const queryClient = useQueryClient();

    return useCallback(async () => {
        if (membership == null) {
            return;
        }
        const key = getMembershipDetailsQueryKey({
            membershipId: membership.id,
        });
        await queryClient.refetchQueries({ queryKey: [key], exact: true });
        const fresh = queryClient.getQueryData<MembershipDetails>([key]);
        const freshIncomes = fresh?.membershipIncomes ?? [];
        const nextMonthly = roundCentsToWholeDollarCents(
            calculateMonthlyTakeHomeCents(freshIncomes),
        );
        await persistMonthlyIncomeCentsToMoneyMap(nextMonthly);
    }, [membership, persistMonthlyIncomeCentsToMoneyMap, queryClient]);
};
